import React from 'react';
import { Tooltip, Zoom } from '@mui/material';
import { Info } from 'lucide-react';

export type InfoSection = { title: string; lines: string[] };

const TOOLTIP_SX = {
  bgcolor: '#1f2937',
  maxWidth: 340,
  padding: '8px 10px',
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: 1.5,
  textAlign: 'left',
  whiteSpace: 'pre-line',
  '& .MuiTooltip-arrow': { color: '#1f2937' },
} as const;

const ICON_STYLE: React.CSSProperties = {
  flex: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  color: '#8094B5',
  cursor: 'default',
  outline: 'none',
};

const SECTION_STYLE = (first: boolean): React.CSSProperties => (first ? {} : { marginTop: 8, paddingTop: 8, borderTop: '1px solid rgba(255,255,255,0.18)' });
const HEADING_STYLE: React.CSSProperties = { marginBottom: 2, fontWeight: 600, color: '#fff' };
const LINE_STYLE: React.CSSProperties = { color: '#E5E7EB' };

const plainText = (sections: InfoSection[]) => sections.map(s => [s.title].concat(s.lines).join('\n')).join('\n\n');

function Sections({ sections }: { sections: InfoSection[] }) {
  return (
    <div>
      {sections.map((s, i) => (
        <div key={s.title} style={SECTION_STYLE(i === 0)}>
          <div style={HEADING_STYLE}>{s.title}</div>
          {s.lines.map(line => <div key={line} style={LINE_STYLE}>{line}</div>)}
        </div>
      ))}
    </div>
  );
}

export default function InfoTip({ text, label }: { text?: string | InfoSection[]; label?: string }) {
  if (!text || (Array.isArray(text) && !text.length)) return null;
  const plain = Array.isArray(text) ? plainText(text) : text;
  return (
    <Tooltip TransitionComponent={Zoom} title={Array.isArray(text) ? <Sections sections={text} /> : text} placement="top" arrow describeChild componentsProps={{ tooltip: { sx: TOOLTIP_SX } }}>
      <span role="img" tabIndex={0} aria-label={label ? label + ': ' + plain : plain} style={ICON_STYLE}>
        <Info size={15} strokeWidth={1.75} aria-hidden="true" />
      </span>
    </Tooltip>
  );
}
